import { useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { Alert, Button, Flex, Result, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import { savePendingVoucher } from '@/features/portal/pendingVoucher'
import { cardFromFragment } from '@/features/portal/voucherCard'
import { parsePortalParams } from '@/shared/lib/portalParams'
import { sessionStore } from '@/shared/lib/sessionStore'
import { PortalShell } from '@/shared/ui/PortalShell'

// Oddiy HTTP manzil: hotspot uni ushlab, shu tabni parametrlari bilan portalga qaytaradi.
const CAPTIVE_PROBE_URL = import.meta.env.VITE_CAPTIVE_PROBE_URL || 'http://neverssl.com/'

/**
 * Kartadagi QR ochadigan sahifa. MAC va zona yo'q — karta faqat shu tabning xotirasida eslab
 * qolinadi va hotspot portali (`/p?mac=...`) ochilganda o'zi qo'llanadi.
 */
export function VoucherLinkPage() {
  const { t } = useTranslation()
  const { search } = useLocation()
  const [card] = useState(() => cardFromFragment(window.location.hash))
  const [saved] = useState(() => card !== null && savePendingVoucher(sessionStore(), card))
  const inHotspotFlow = parsePortalParams(search) !== null

  useEffect(() => {
    window.history.replaceState(null, '', window.location.pathname + window.location.search)
  }, [])

  if (card === null) {
    return (
      <PortalShell>
        <Result status="warning" title={t('voucherLink.invalidTitle')} subTitle={t('voucherLink.invalidText')} />
      </PortalShell>
    )
  }

  if (saved && inHotspotFlow) {
    return <Navigate to={`/p${search}`} replace />
  }

  const notSavedText = card.kind === 'code' ? t('voucherLink.notSaved') : t('voucherLink.notSavedToken')

  return (
    <PortalShell>
      <Result
        status={saved ? 'success' : 'info'}
        title={t('voucherLink.title')}
        subTitle={saved ? t('voucherLink.text') : notSavedText}
        extra={
          <Flex vertical gap={12}>
            {card.kind === 'code' ? (
              <>
                <Typography.Text type="secondary">{t('voucherLink.codeLabel')}</Typography.Text>
                <Typography.Text strong copyable={{ text: card.code }} style={{ fontSize: 18, letterSpacing: 1 }}>
                  <bdi dir="ltr">{card.code}</bdi>
                </Typography.Text>
              </>
            ) : null}
            {saved ? (
              <>
                <Button type="primary" size="large" block onClick={() => window.location.assign(CAPTIVE_PROBE_URL)}>
                  {t('common.continue')}
                </Button>
                <Alert type="info" showIcon message={t('voucherLink.hint')} />
              </>
            ) : null}
          </Flex>
        }
      />
    </PortalShell>
  )
}
